module.exports = __webpack_public_path__ + "media/xingshi.3bc56f59.mp3";